import { useMemo } from "react";
import { config } from "../config";

export const useApiHeaders = (
  accessToken,
  userRole,
  project,
  platformName,
  vaultId
) => {
  return useMemo(() => {
    if (!accessToken) return {};

    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };

    if (platformName !== config.platforms[0]) {
      headers.vaultName = vaultId;
    } else {
      headers.smRegion = vaultId;
    }

    if (project && userRole && !["devops", "default"].includes(userRole)) {
      headers.project = project;
    }

    if (userRole) {
      headers.CurrentRole = userRole;
    }

    return headers;
  }, [accessToken, userRole, project, platformName, vaultId]);
};
